import React from 'react';
import { FadeIn } from './FadeIn';
import { AlertTriangle } from 'lucide-react';
export function ProblemSection() {
  return <section className="bg-primary-dark text-text-dark py-20 md:py-28 border-t border-secondary-dark" data-id="element-156">
      <div className="container mx-auto px-6 max-w-4xl" data-id="element-157">
        <FadeIn data-id="element-158">
          <div className="flex justify-center mb-6" data-id="element-159">
            <div className="p-3 bg-red-500/10 rounded-full text-red-400" data-id="element-160">
              <AlertTriangle size={32} data-id="element-161" />
            </div>
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12" data-id="element-162">
            El clima laboral está{' '}
            <span className="text-red-400" data-id="element-163">incendiado</span>.
          </h2>
        </FadeIn>

        <div className="grid md:grid-cols-2 gap-8 md:gap-12" data-id="element-164">
          <FadeIn delay={0.1} data-id="element-165">
            <div className="bg-secondary-dark/40 p-8 rounded-xl border border-secondary-dark h-full" data-id="element-166">
              <p className="text-lg leading-relaxed text-text-muted" data-id="element-167">
                En Argentina, la presión económica y la falta de límites
                hicieron que{' '}
                <strong className="text-text-dark" data-id="element-168">
                  "ponerse la camiseta"
                </strong>{' '}
                signifique regalar tu salud mental.
              </p>
            </div>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-169">
            <div className="bg-secondary-dark/40 p-8 rounded-xl border border-secondary-dark h-full" data-id="element-170">
              <p className="text-lg leading-relaxed text-text-muted" data-id="element-171">
                Estás en{' '}
                <strong className="text-text-dark" data-id="element-172">modo supervivencia</strong>.
                Terminás el día tan agotado que no tenés energía para tu
                familia, tu entrenamiento o tus proyectos.
              </p>
            </div>
          </FadeIn>
        </div>

        <FadeIn delay={0.3} data-id="element-173">
          <div className="mt-12 text-center bg-accent/5 border border-accent/20 p-8 rounded-xl" data-id="element-174">
            <p className="text-xl md:text-2xl font-serif text-accent" data-id="element-175">
              Sentís que si seguís así, en seis meses te fundís. La neblina
              mental y la irritabilidad ya son parte de tu rutina diaria.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}